var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-edit-background-image-button",on:{"click":_vm.editBackgroundImage}},[_vm._v("Edit Background Image")])
}
var staticRenderFns = []

export { render, staticRenderFns }